export const initialise = () => {
    const page = document.querySelector<HTMLBodyElement>('.page-jobs')
    const widget = document.querySelector<HTMLElement>('.search-filters-widget')
    if (!page || !widget) return
    header(widget)
    moveFilterButtons(widget)
    locationFilter(widget)
    filters(widget)
    optionDisplayLists(widget)
    moveKeyword(widget)
    enableSearchOnEnter(widget)
    clearSearchOnChange(widget)
}

const header = (widget: HTMLElement) => {
    const header = widget.querySelector<HTMLDivElement>('#filter-header')
    if (!header) return
    const filtersContainer = widget.querySelector<HTMLDivElement>('.search-filters-widget__filter-list')
    if (!filtersContainer) return

    const button: HTMLButtonElement = document.createElement('button')
    button.className = 'page-jobs__filters-button'
    button.innerHTML = '{{js.page.jobs.filters.header}}'
    button.setAttribute('aria-expanded', 'false')
    header.appendChild(button)

    const link: HTMLAnchorElement = document.createElement('a')
    link.className = 'page-jobs__filters-link'
    link.innerHTML = '{{js.page.jobs.filters.clear.text}}'
    link.ariaLabel = '{{js.page.jobs.filters.clear.aria-label}}'
    link.href = '{{js.page.jobs.filters.clear.href}}'
    header.appendChild(link)

    filtersContainer.classList.add('search-filters-widget__filter-list--visible')
    filtersContainer.setAttribute('aria-hidden', 'false')

    button.addEventListener('click', function(event: Event) {
        const isExpanded: boolean = filtersContainer.classList.toggle('search-filters-widget__filter-list--visible')
        button.setAttribute('aria-expanded', isExpanded.toString())
    })

    const debounce = (func: () => void, wait: number) => {
        let timeout: number | undefined
        return () => {
            clearTimeout(timeout)
            timeout = window.setTimeout(func, wait)
        }
    }

    const handleResize = debounce(() => {
        if (window.innerWidth > 991) {
            filtersContainer.classList.add('search-filters-widget__filter-list--visible')
            filtersContainer.setAttribute('aria-hidden', 'false')
            button.setAttribute('aria-expanded', 'true')
        }
    }, 200)

    window.addEventListener('resize', handleResize)
}

const moveFilterButtons = (widget: HTMLElement) => {
    const filters = widget.querySelectorAll<HTMLElement>('.optionfiltergroup')

    filters.forEach((filter: HTMLElement) => {
        const applyButtonContainer = filter.querySelector('.apply-filters-btn-container')
        const applyButton = filter.querySelector('.apply-filters-btn')
        const buttonContainer = filter.querySelector('.job-filter-buttons-container')

        if (!buttonContainer || !applyButton || !applyButtonContainer) return
        buttonContainer.prepend(applyButton)
        applyButtonContainer?.remove()
    })
}

const locationFilter = (widget: HTMLElement) => {
    const locationFilter = widget.querySelector<HTMLDivElement>('.location-filter')
    if (!locationFilter) return

    const header = locationFilter.querySelector<HTMLHeadingElement>('.header')
    if (!header) return

    const button: HTMLButtonElement = document.createElement('button')
    button.className = header.className
    button.innerHTML = header.innerHTML
    
    header.replaceWith(button)
}

const toggleFilter = (filter: HTMLDivElement, button: HTMLButtonElement, list: HTMLUListElement) => {
    filter.classList.toggle('category-opened')

    const isExpanded: boolean = filter.classList.contains('category-opened')
    list.setAttribute('aria-hidden', (!isExpanded).toString())
    button.setAttribute('aria-expanded', isExpanded.toString())
}

const filters = (widget: HTMLElement) => {
    const filters: NodeListOf<HTMLDivElement> = widget.querySelectorAll('.optionfiltergroup, .location-filter')

    filters.forEach((filter: HTMLDivElement) => {
        const button = filter.querySelector<HTMLButtonElement>('.option-type-header-text, .header')
        if (!button) return

        const list = filter.querySelector<HTMLUListElement>('.option-display-list, .location-slider-wrapper')
        if (!list) return

        list.setAttribute('aria-hidden', 'true')
        button.setAttribute('aria-expanded', 'false')

        button.addEventListener('click', function(event: Event) {
            toggleFilter(filter, button, list)
        })

        window.addEventListener('load', () => {
            const count = button.querySelector<HTMLElement>('.optionfiltergroup__count')
            if (count && count.innerText.trim() !== '') {
                toggleFilter(filter, button, list)
            }
        })
    })
}

const optionDisplayLists = (widget: HTMLElement) => {
    const options = widget.querySelectorAll<HTMLButtonElement>('.filter-option.has-child-elements')

    options.forEach((option: HTMLButtonElement) => {
        option.setAttribute('aria-hidden', 'true')

        const button = option.querySelector<HTMLButtonElement>('.filter-expand-hide')
        if (!button) return

        button.setAttribute('aria-expanded', 'false')
        button.addEventListener('click', function(event: Event) {
            option.classList.toggle('filter-opened')
            const isExpanded: boolean = option.classList.contains('filter-opened')
            button.setAttribute('aria-expanded', isExpanded.toString())
        })
    })
}

const moveKeyword = (widget: HTMLElement) => {
    const keywordElement = widget.querySelector<HTMLElement>('#keyword-option-wrapper')
    if (!keywordElement) return

    const container = document.querySelector<HTMLDivElement>('.page-jobs__container-filters .container-col')
    container?.append(keywordElement)
}

const enableSearchOnEnter = (widget: HTMLElement) => {
    const searchInput = widget.querySelector<HTMLInputElement>('.search-filters-widget__filter-search-input')
    if (!searchInput) return

    searchInput.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Enter') {
            event.preventDefault()
            const parentElement = searchInput.closest<HTMLDivElement>('.search-filters-widget__filter-search')
            const searchButton = parentElement?.querySelector<HTMLButtonElement>('.search-filters-widget__filter-search-btn')
            searchButton?.click()
        }
    })
}

const clearSearchOnChange = (widget: HTMLElement) => {
    const searchInput = widget.querySelector<HTMLInputElement>('.search-filters-widget__filter-search-input')
    if (!searchInput) return

    const searchButton = widget?.querySelector<HTMLButtonElement>('.search-filters-widget__filter-search-btn')
    if (!searchButton) return

    searchInput.addEventListener('input', () => {
        if (searchInput.value === '') {
            searchButton?.click()
        }
    })
}